import { css } from "../../../styled-system/css";

export const styles = {
  popupContainer: () =>
    css({
      maxWidth: "284px",
      desktop: {
        maxWidth: "650px",
      },
      "& p": {
        marginBottom: "2px",
        fontSize: "body.shrimp",
        lineHeight: "body.shrimp",
        letterSpacing: "body.shrimp",
        fontWeight: "bold",
        color: "black",
        desktop: {
          marginBottom: "baseUnit.mobile1",
          fontSize: "body.mouse",
          lineHeight: "body.mouse",
          letterSpacing: "body.mouse",
        },
      },
      "& > div": {
        _first: {
          padding: "4px",
          "& svg path": {
            fill: "black",
          },
        },
      },
    }),
  popupContent: () =>
    css({
      padding: "baseUnit.mobile2",
    }),
  popupList: () =>
    css({
      listStyleType: "disc",
      paddingLeft: "baseUnit.mobile3",
      margin: 0,
      desktop: {
        columnCount: 3,
        columnGap: "32px",
      },
    }),
  popupListItem: () =>
    css({
      color: "black",
      fontSize: "body.shrimp",
      lineHeight: "body.shrimp",
      letterSpacing: "body.shrimp",
      paddingY: "1px",
      _last: {
        paddingBottom: 0,
      },
      desktop: {
        fontSize: "body.mouse",
        lineHeight: "body.mouse",
        letterSpacing: "body.mouse",
      },
    }),
};
